import { TAGS } from '@web-app/components/PatientTags/constants';
import DiabetesOrPrediabetesTemplateUsageReminderModal from '@web-app/components/tagActions/DiabetesOrPrediabetesTemplateUsageReminderModal';
import FactorReminderModal from '@web-app/components/tagActions/FactorReminderModal';
import FertilityTemplateUsageReminderModal from '@web-app/components/tagActions/FertilityTemplateUsageReminderModal';
import HeartHealthTemplateUsageReminderModal from '@web-app/components/tagActions/HeartHealthTemplateUsageReminderModal';
import LingoReminderModal from '@web-app/components/tagActions/LingoReminderModal';
import MayoReminderModal from '@web-app/components/tagActions/MayoReminderModal';
import MbiotaReminderModal from '@web-app/components/tagActions/MbiotaReminderModal';
import PregnancyOrPostNatalTemplateUsageReminderModal from '@web-app/components/tagActions/PregnancyOrPostNatalTemplateUsageReminderModal';
import SignosReminderModal from '@web-app/components/tagActions/SignosReminderModal';
import WalmartReminderModal from '@web-app/components/tagActions/WalmartReminderModal';
import React from 'react';

import GLP1TemplateUsageReminderModal from '../../components/tagActions/GLP1TemplateUsageReminderModal';
import PreGLP1TemplateUsageReminderModal from '../../components/tagActions/PreGLP1TemplateUsageReminderModal';
import WondrMobileAppModal from '../../components/tagActions/WondrMobileAppModal';
import { CallPhase, TagActionRule } from './types';

// Default rules for pre-call tag actions
export const defaultTagActionRules: TagActionRule[] = [
  {
    id: 'wondr-mobile-app',
    phase: CallPhase.PreCall,
    tagNames: ['wondr'],
    requireAllTags: false,
    actions: [
      {
        id: 'wondr-app-reminder',
        title: 'Wondr App Reminder',
        description: 'Remind patient to use mobile app',
        renderAction: () => React.createElement(WondrMobileAppModal),
      },
    ],
  },
  {
    id: 'glp1-mobile-app',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.GLP_1],
    requireAllTags: false,
    actions: [
      {
        id: 'glp1-reminder',
        title: 'GLP-1 App Reminder',
        description: 'Remind provider to use templates',
        renderAction: () => React.createElement(GLP1TemplateUsageReminderModal),
      },
    ],
  },
  {
    id: 'pre-glp1-mobile-app',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.PRE_GLP_1],
    requireAllTags: false,
    actions: [
      {
        id: 'pre-glp1-reminder',
        title: 'PRE-GLP-1 App Reminder',
        description: 'Remind provider to use PRE-GLP-1 templates',
        renderAction: () =>
          React.createElement(PreGLP1TemplateUsageReminderModal),
      },
    ],
  },
  {
    id: 'fertility-mobile-app',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.FERTILITY],
    requireAllTags: false,
    actions: [
      {
        id: 'fertility-reminder',
        title: 'Fertility App Reminder',
        description: 'Remind provider to use Fertility templates',
        renderAction: () =>
          React.createElement(FertilityTemplateUsageReminderModal),
      },
    ],
  },
  {
    id: 'pregnancy-or-post-natal-mobile-app',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.PREGNANCY_AND_POSTPARTUM],
    requireAllTags: false,
    actions: [
      {
        id: 'pregnancy-or-post-natal-reminder',
        title: 'Pregnancy or Post Natal App Reminder',
        description: 'Remind provider to use Pregnancy or Post Natal templates',
        renderAction: () =>
          React.createElement(PregnancyOrPostNatalTemplateUsageReminderModal),
      },
    ],
  },
  {
    id: 'heart-health-mobile-app',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.HEART_HEALTH],
    requireAllTags: false,
    actions: [
      {
        id: 'heart-health-reminder',
        title: 'Heart Health App Reminder',
        description: 'Remind provider to use Heart Health templates',
        renderAction: () =>
          React.createElement(HeartHealthTemplateUsageReminderModal),
      },
    ],
  },
  {
    id: 'diabetes-or-prediabetes-mobile-app',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.DIABETES_OR_PREDIABETES],
    requireAllTags: false,
    actions: [
      {
        id: 'diabetes-or-prediabetes-reminder',
        title: 'Diabetes or Prediabetes App Reminder',
        description: 'Remind provider to use Diabetes or Prediabetes templates',
        renderAction: () =>
          React.createElement(DiabetesOrPrediabetesTemplateUsageReminderModal),
      },
    ],
  },
  {
    id: 'factor-patient-reminders',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.FACTOR],
    requireAllTags: false,
    actions: [
      {
        id: 'factor-patient-reminders',
        title: 'Factor Patient Reminders',
        description: 'Remind provider of Factor partnership talking points',
        renderAction: () => React.createElement(FactorReminderModal),
      },
    ],
  },
  {
    id: 'mayo-patient-reminders',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.MAYO],
    requireAllTags: false,
    actions: [
      {
        id: 'mayo-patient-reminders',
        title: 'Mayo Patient Reminders',
        description: 'Remind provider of Mayo partnership talking points',
        renderAction: () => React.createElement(MayoReminderModal),
      },
    ],
  },
  {
    id: 'signos-patient-reminders',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.SIGNOS],
    requireAllTags: false,
    actions: [
      {
        id: 'signos-patient-reminders',
        title: 'Signos Patient Reminders',
        description: 'Remind provider of Signos partnership talking points',
        renderAction: () => React.createElement(SignosReminderModal),
      },
    ],
  },
  {
    id: 'mbiota-patient-reminders',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.MBIOTA],
    requireAllTags: false,
    actions: [
      {
        id: 'mbiota-patient-reminders',
        title: 'mBIOTA Patient Reminders',
        description: 'Remind provider of mBIOTA partnership talking points',
        renderAction: () => React.createElement(MbiotaReminderModal),
      },
    ],
  },
  {
    id: 'lingo-patient-reminders',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.LINGO],
    requireAllTags: false,
    actions: [
      {
        id: 'lingo-patient-reminders',
        title: 'Lingo Patient Reminders',
        description: 'Remind provider of Lingo partnership talking points',
        renderAction: () => React.createElement(LingoReminderModal),
      },
    ],
  },
  {
    id: 'walmart-patient-reminders',
    phase: CallPhase.PreCall,
    tagNames: [TAGS.WALMART],
    requireAllTags: false,
    actions: [
      {
        id: 'walmart-patient-reminders',
        title: 'Walmart Patient Reminders',
        description: 'Notify provider of Walmart shopping insights',
        renderAction: () => React.createElement(WalmartReminderModal),
      },
    ],
  },
];
